// MUST be the first import so init runs before React mounts
import "./config/sentry";

import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
reportWebVitals();
